// §4.4 partial — admin/payouts routes.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const PayoutsPage = lazyWithRetry(() => import("./pages/PayoutsPage"));

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [{ path: "/admin/payouts", Component: PayoutsPage }],
  },
];

export default routes;
